import React, { useEffect, useState } from "react";
import { Table, Empty, Col, Row } from "antd";
import CurrencyFormat from "react-currency-format";
import { useHistory } from "react-router-dom";
import { RollbackOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";

const ReportMonthlyDetail = (props) => {
  const history = useHistory();
  const [detailReport, setDetailReport] = useState([]);

  useEffect(() => {
    RequestHandler.get(
      `/TenantCurrency?$apply=groupby((Currency,CurrencyId))&$orderby=currencyId`
    ).then((response) => {
      RequestHandler.post(
        `/Reports/GetMonthlyReportsDetailCollect`,
        {
          date: props.match.params.date,
          currencyId: response[0]?.currencyId.toString(),
          currencyCode: props.match.params.currency,
        },
        false
      ).then((res) => {
        setDetailReport(res);
      });
    });
  }, []);

  const columns = [
    {
      title: "Cari",
      dataIndex: "firmName",
      width: "20%",
      render: (text, row, index) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "Cari Kodu",
      dataIndex: "firmCode",
      width: "20%",
      render: (text, row, index) => {
        return <div>{text}</div>;
      },
    },
    {
      title: "Plan",
      dataIndex: "collectPlanTotal",
      width: "20%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {",00"}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Gerçekleşen",
      dataIndex: "collectTotal",
      width: "20%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {",00"}
              </div>
            );
          }
        }
      },
    },
  ];

  return (
    <div>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%" }}
            columns={columns}
            size="small"
            dataSource={detailReport}
            rowKey="Id"
            bordered
            title={() => `TAHSİLAT DETAY - ( ${props.match.params.currency} )`}
            footer={() => ""}
          />
        </Col>
      </Row>
    </div>
  );
};
export default ReportMonthlyDetail;
